import React, { useEffect, useState } from "react";
import Router from "./Router";
import { ToastContainer } from "react-toastify";
import AdBlockDetector from "./components/AdBlockDetector";
import { useLocation } from "react-router-dom";
import AuthErrorModal from "./components/AuthErrorModal";
import MoreAppsModal from "./components/MoreAppsModal";
import { MoreAppsProvider } from "./context/MoreAppsContext";
import {
  addAuthErrorListener,
  getToken,
  notifySessionRefreshed,
  refreshTokenFlow,
  retryLastFailedRequest,
} from "./services/handler";
import { initDeviceSession } from "./utils/deviceSecurity";

function App() {
  const location = useLocation();
  const showAdBlocker = location.pathname !== "/diet-plan/delete-user";
  const [isAuthErrorModalOpen, setIsAuthErrorModalOpen] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      try {
        await initDeviceSession("SnaptoonWeb");
        const token = await getToken();
        if (!token) {
          await refreshTokenFlow();
        }
      } catch (err) {
        console.log("App init auth error:", err);
      }
    };
    initAuth();

    const unsubscribe = addAuthErrorListener(() => {
      setIsAuthErrorModalOpen(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleRefreshSession = async () => {
    const newToken = await refreshTokenFlow();
    if (newToken) {
      await retryLastFailedRequest();
      notifySessionRefreshed();
      setIsAuthErrorModalOpen(false);
    } else {
      throw new Error("Failed to renew session");
    }
  };

  return (
    <MoreAppsProvider>
      <div className="App">
        {showAdBlocker && <AdBlockDetector />}
        <ToastContainer />
        <Router />
        <AuthErrorModal
          isOpen={isAuthErrorModalOpen}
          onClose={() => setIsAuthErrorModalOpen(false)}
          onRefresh={handleRefreshSession}
        />
        <MoreAppsModal />
      </div>
    </MoreAppsProvider>
  );
}

export default App;

